import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useVaxFormData = () => {
	const [isFromInternet, setIsFromInternet] = useState(false);
	const vaxFormData = useSelector((state) => state.vaxFormData);

	useEffect(() => {
		if (!vaxFormData) {
			return;
		}
		if (vaxFormData.glob_referrer_id == '1') {
			setIsFromInternet(true);
		} else {
			setIsFromInternet(false);
		}
	}, [vaxFormData]);

	return { isFromInternet };
};

export default useVaxFormData;
